import { useCallback, useEffect, useState } from 'react'
import { ButtonSecondary, ButtonPrimary } from '../../../../../../baseComponents/Button'
import { ModalBigCentered } from '../../../../../../baseComponents/Modal'
import { RowData, TableData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import TableWithoutVirtualListing from '../../../../../../baseComponents/TwinTable/TableWithoutVirtualListing'
import Checkbox from '../../../../../../forms/Checkbox'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalMultipleMatchProductWorkSheetProps extends ModalMultipleMatchProductWorkSheetLogicProps {
}

interface MatchProductsParams {
    WorkSheetProductMatchId: string,
    WorkSheetProductId: string,
    productNLine: string,
    productNameReference: string,
    selected: boolean
}

const ModalMultipleMatchProductWorkSheet: React.FC<ModalMultipleMatchProductWorkSheetProps> = ({ ...logic }) => {
    const { t } = useTwinTranslation()
    const { groupWorkSheetProducts, matchProducts, selectAllProducts, handleSelectSingleProduct, myOnSubmit } = useModalMultipleMatchProductWorkSheetLogic({ ...logic })
    if (!matchProducts || !matchProducts.length) {
        return null
    }
    const columns: ColumnTableSchema<MatchProductsParams> = [
        {
            id: 'productNameReference',
            dataKey: 'productNameReference',
            label: t('product', 'Producto'),
        },
        {
            id: 'selected',
            dataKey: 'selected',
            label: () => <Checkbox label={''} onClick={selectAllProducts} />,
            customRender: (value: any, allRowData) => <Checkbox label={''} checked={value === true} onClick={() => handleSelectSingleProduct(allRowData.absoluteIndex || allRowData.rowIndex)}/>,
            width: 50,
        },
    ]
    return (
        <ModalBigCentered opened={true} setOpened={() => logic.setOpenModal(null)} className='modal_skip_operate_stock_order flex_height flex-auto flex'>
            <h2 className='mb-20'>
                <TwinTrans transKey={'productsWithSameStatusOfProduct'}>Se han encontrado productos con el mismo estado y referencia</TwinTrans>
            </h2>
            <div className='flex flex-col flex-auto h-300'>
                <TableWithoutVirtualListing data={matchProducts} columns={columns}/>
            </div>
            <span className='my-20'><TwinTrans transKey={'groupLinesOrKeepSeparated'}>Puedes juntar las líneas de producto o mantenerlas separadas.</TwinTrans></span>
            <ButtonSecondary onClick={myOnSubmit} className='mb-10'>
                <TwinTrans transKey={'keepSeparate'}>Mantenerlas separadas</TwinTrans>
            </ButtonSecondary>
            <ButtonPrimary onClick={groupWorkSheetProducts}>
                <TwinTrans transKey={'groupSelectedLines'}>Juntar las líneas seleccionadas</TwinTrans>
            </ButtonPrimary>
        </ModalBigCentered>
    )
}

interface ModalMultipleMatchProductWorkSheetLogicProps {
    allRowData: RowData
    setOpenModal: SetEditDeleteModalTy
    getData: (inputtable?: TableData) => Promise<void>
}

const useModalMultipleMatchProductWorkSheetLogic = ({ allRowData, getData, setOpenModal }: ModalMultipleMatchProductWorkSheetLogicProps) => {
    const [matchProducts, setMatchProducts] = useState<MatchProductsParams[] | null>(null)

    const getMatchProducts = useCallback(() => {
        if (allRowData && allRowData.matchProducts) {
            const products = allRowData.matchProducts.split('matchProduct-_-')
            const myProductResult: MatchProductsParams[] = []
            for (const element of products) {
                if (element) {
                    const errorSplit = element.split('-_-')
                    const WorkSheetProductMatchId = errorSplit[0]
                    const WorkSheetProductId = errorSplit[1]
                    const productNLine = errorSplit[2]
                    const productReference = errorSplit[3]
                    const productName = errorSplit[4]
                    myProductResult.push({
                        WorkSheetProductMatchId,
                        WorkSheetProductId,
                        productNLine,
                        productNameReference: productName + ' - ' + productReference,
                        selected: false
                    })
                }
            }
            setMatchProducts(myProductResult)
        }
    }, [allRowData, setMatchProducts])

    const selectAllProducts = useCallback(() => {
        setMatchProducts((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            for (const element of copyOld) {
                element.selected = true
            }
            return copyOld
        })
    }, [setMatchProducts])

    const handleSelectSingleProduct = useCallback((rowIndex: any) => {
        setMatchProducts((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            const isSelected = copyOld[rowIndex].selected
            copyOld[rowIndex].selected = !isSelected
            return copyOld
        })
    }, [setMatchProducts])
    
    const myOnSubmit = useCallback(() => {
        getData()
        setOpenModal(null)
    }, [getData, setOpenModal])
    
    const groupWorkSheetProducts = useCallback(async () => {
        const mySelectedProducts = []
        for (const element of matchProducts || []) {
            if (element.selected) {
                mySelectedProducts.push({ WorkSheetProductId: element.WorkSheetProductId, WorkSheetProductMatchId: element.WorkSheetProductMatchId })
            }
        }
        const result = await twinFetchPostJSON('/api/app/order/sell/workSheet/workSheetProduct/groupMultipleWorkSheetProducts', { matchProducts: mySelectedProducts })
        if (result) {
            myOnSubmit()
        }
    }, [matchProducts, myOnSubmit])

    useEffect(() => {
        getMatchProducts()
    }, [getMatchProducts])

    return { groupWorkSheetProducts, matchProducts, selectAllProducts, handleSelectSingleProduct, myOnSubmit }
}

export default ModalMultipleMatchProductWorkSheet